import React from 'react';
import { Tooltip } from 'antd';
import { CircleCheck, TriangleAlert, CircleAlert, Copy } from 'lucide-react';
import { StatusTag } from '../../common';

export function BarcodeIcon({ barcodeMeta, hasCatalogMatch }) {
    if (!barcodeMeta) return null;
    if (barcodeMeta.valid && hasCatalogMatch !== false) {
        return (
            <Tooltip title={`${barcodeMeta.format} — checksum válido`}>
                <CircleCheck className="shrink-0 text-[15px] text-success-fg" />
            </Tooltip>
        );
    }
    if (!barcodeMeta.checkDigitOk || !barcodeMeta.valid) {
        return (
            <Tooltip title={barcodeMeta.warnings?.join(', ') || 'Código inválido'}>
                <TriangleAlert className="shrink-0 text-[15px] text-danger-fg" />
            </Tooltip>
        );
    }
    return (
        <Tooltip title="Formato válido pero sin coincidencia en catálogo">
            <CircleAlert className="shrink-0 text-[15px] text-warning-fg" />
        </Tooltip>
    );
}

export default function AuditFlagChips({ flags = {}, barcodeMeta, showBarcode = true }) {
    const chips = [];

    if (showBarcode && barcodeMeta && !barcodeMeta.valid) {
        chips.push(
            <StatusTag key="barcode" tone="danger">
                Código inválido
            </StatusTag>
        );
    }
    if (flags?.mismatch) {
        chips.push(
            <StatusTag key="mismatch" tone="danger">
                Código ≠ catálogo
            </StatusTag>
        );
    }
    if (flags?.fieldCreated) {
        chips.push(
            <StatusTag key="field" tone="warning">
                Producto creado en campo
            </StatusTag>
        );
    }
    if (flags?.duplicateInVisit) {
        chips.push(
            <StatusTag key="dup-visit" tone="warning" icon={<Copy />}>
                Duplicado en visita
            </StatusTag>
        );
    }
    if (flags?.duplicateRecent || flags?.duplicate) {
        chips.push(
            <StatusTag key="dup-recent" tone="info" icon={<Copy />}>
                Visto recientemente (24h)
            </StatusTag>
        );
    }
    if (flags?.noCatalogMatch) {
        chips.push(
            <StatusTag key="nocat" tone="neutral">
                Sin catálogo
            </StatusTag>
        );
    }
    if (flags?.pendingEnrichment) {
        chips.push(
            <StatusTag key="pend" tone="warning">
                Pendiente ajuste
            </StatusTag>
        );
    }
    if (flags?.missingData) {
        chips.push(
            <StatusTag key="missing" tone="danger">
                Datos mínimos
            </StatusTag>
        );
    }
    if (flags?.suspectedBsMislabel) {
        chips.push(
            <StatusTag key="bs-mislabel" tone="danger" icon={<TriangleAlert />}>
                Moneda sospechosa
            </StatusTag>
        );
    }

    if (!chips.length) return null;
    return <div className="flex flex-wrap gap-1">{chips}</div>;
}
